module.exports = __webpack_public_path__ + "media/images/talent/case06-illust-4bd5696016de99a1b4edcd0622f3c5e3.png";